// services/planApi.js
import axiosInstance from "./AxiosInstance";

const getCurrentTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
};

export const createDietPlan = () => {
  return axiosInstance.post("api/create-diet-plan", {
    start_time: getCurrentTime(),
  });
};

export const createExercisePlan = () => {
  return axiosInstance.post("api/exercise/create-plan", {
    start_time: getCurrentTime(),
  });
};
